var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingcartIconNavbar = function SvgShoppingcartIconNavbar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.28,
    height: 19.857
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108596",
    d: "m.58.01 3.14.711a.534.534 0 0 1 .355.355l.474 2.31 15.344 1.481a.432.432 0 0 1 .355.592l-2.37 7.287a.446.446 0 0 1-.415.3H6.564l.237 1.126h10.486c.592 0 .592 1.066 0 1.066H6.269a.433.433 0 0 1-.415-.355L3.128 1.669.343 1.081C-.249.903-.012-.104.58.015Z",
    fill: "#eff0f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108597",
    d: "M8.638 15.769a2.044 2.044 0 1 1-2.074 2.014 2.048 2.048 0 0 1 2.074-2.014Zm0 1.007a1.038 1.038 0 0 0-1.007 1.007 1.007 1.007 0 1 0 2.014 0 1.038 1.038 0 0 0-1.007-1.007Z",
    fill: "#eff0f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108598",
    d: "M15.035 15.769a2.044 2.044 0 1 1-2.014 2.014 2.012 2.012 0 0 1 2.014-2.014Zm0 1.007a.987.987 0 0 0-.948 1.007.951.951 0 0 0 .948 1.007.964.964 0 0 0 1.007-1.007 1 1 0 0 0-1.007-1.007Z",
    fill: "#eff0f6"
  })));
};
export default SvgShoppingcartIconNavbar;